<template>
  <section>
    <div id="validContainer" style="width:100%;">
      <div id="validBG"></div>
      <div id="validMoveBox" style="left:0;">
        <i :class="iconStyle"></i>
      </div>
      <div id="validTitle">拖动滑块验证</div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    validFlag: {
        type: Boolean,
        default: false
    },
    mainContainer: {
        type: HTMLElement,
        default: function(){
          return document.getElementsByTagName('section')[0];
        }
    }
  },
  data() {
    return {
      validMoveBox: '',
      validBG: '',
      validContainer: '',
      validTitle: '',
      iconStyle: "el-icon-d-arrow-right",
      
    };
  },
  methods: {
    initSlide() {
      this.initView();
      this.$emit('change',false);
      this.validMoveBox.onmousedown = e => {
        var mouseDownx = e.clientX;
        console.log(mouseDownx);
        this.mainContainer.onmousemove = e => {
          var moveX = e.clientX - mouseDownx;
          if (moveX < 0) {
            return;
          }
          this.validMoveBox.style.left = moveX + "px";
          this.validBG.style.width = moveX + "px";

          if (moveX >= this.validContainer.offsetWidth - 42) {
            this.mainContainer.onmousemove = e => {
              this.validMoveBox.style.left =
                this.validContainer.offsetWidth - 42 + "px";
              this.validBG.style.width =
                this.validContainer.offsetWidth - 42 + "px";
              this.validTitle.style.color = "#fff";
              this.validTitle.innerText = "验证通过";
              this.validMoveBox.onmousedown = null;
              this.mainContainer.onmousemove = null;
              // this.validFlag = true;
              this.$emit('change',true);
              this.iconStyle = "el-icon-success";
            };
          }
        };
      };
      this.validMoveBox.onmouseup = e => {
        var left = this.validMoveBox.style.left.split("px")[0];
        if (left < this.validContainer.offsetWidth - 42) {
          this.validMoveBox.style.left = "0";
          this.validBG.style.width = "0";
        }
        this.mainContainer.onmousemove = null;
      };
    },
    initView(){
      this.validContainer = document.getElementById("validContainer");
      this.validMoveBox = document.getElementById("validMoveBox");
      this.validBG = document.getElementById("validBG");
      this.validTitle = document.getElementById("validTitle");
      this.validMoveBox.style.left = "0";
      this.validBG.style.width = "0";
      this.iconStyle = "el-icon-d-arrow-right";
    }
  },
  mounted() {
    this.initSlide();
  }
};
</script>
<style lang="less" scoped>
#validContainer {
  position: relative;
  background-color: #ddd;
  border-radius: 5px;
  height: 40px;
  #validBG {
    position: absolute;
    background-color: #7ac23c;
    border-radius: 5px;
    height: 40px;
  }
  #validTitle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  #validMoveBox {
    position: absolute;
    background-color: #fff;
    width: 40px;
    height: 38px;
    border: 1px solid #aaa;
    text-align: center;
    cursor: move;
    z-index: 9999;
    .el-icon-success {
      color: #7ac23c;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/slideValid.vue